import { __decorate, __metadata } from "tslib";
import { IsUUID } from 'class-validator';
import { UUID_VERSION } from '../../type/shared';
/**
 * Retrieve a list of transcript ordering features for multiple court systems
 */
export class ListTranscriptOrderingFeatureForCourtSystemsBody {
}
__decorate([
    IsUUID(UUID_VERSION, { each: true }),
    __metadata("design:type", Array)
], ListTranscriptOrderingFeatureForCourtSystemsBody.prototype, "courtSystemIds", void 0);
